import { getPhoneCom } from 'phonecom'
import { getOtherUseCaseTextValue, useCasesOptions, replacePlaceholderWithActualBrandValues } from './util'

/*
 This is documentation for these payloads:
 https://docs.google.com/document/d/1sgnbuSRERxTCoWOpKEA1DQKOkibPTzQcVmnTLzKTyng/edit?tab=t.0
*/

/**
 *
 */
const getAddBrandParams = async (wizardData) => {
    const phonecom = await getPhoneCom()

    return {
        business_info: {
            legalBizName: wizardData.business_info.legalBizName,
            registrationCountry: wizardData.business_info.registrationCountry,
            federalBusinessID: wizardData.business_info.federalBusinessID,
            selectedBizType: wizardData.business_info.selectedBizType,
            selectedVerticle: wizardData.business_info.selectedVerticle,
            stockSymbol: wizardData.business_info.stockSymbol,
            brandName: wizardData.business_info.brandName
        },
        business_address: {
            address: wizardData.business_address.address,
            address_2: wizardData.business_address.address_2,
            state: wizardData.business_address.state,
            city: wizardData.business_address.city,
            postalCode: wizardData.business_address.postalCode,
            primaryBusinessPhone: wizardData.business_address.primaryBusinessPhone,
            supportPhone: wizardData.business_address.supportPhone,
            bizWebsite: wizardData.business_address.bizWebsite,
            supportEmail: wizardData.business_address.supportEmail
        },
        business_confirm: true,
        account_id: phonecom.voip_id,
        mock: wizardData.business_address.mock
    }
}

/**
 *
 */
const getEditBrandParams = async (wizardData, editing) => {
    // payment-failed goes directly to the last step
    // so we dont have data before that
    let data = {
        csp_brand_id: editing.csp_brand_id
        // identifier:
        // business_identifier:
        // registration_status:
        // deleted_at:
    }
    if (wizardData?.business_address) {
        data = {
            ...data,
            mobile_phone: wizardData.business_address.primaryBusinessPhone,
            company: wizardData.business_address.bizWebsite,
            address: wizardData.business_address.address,
            address_2: wizardData.business_address.address_2,
            city: wizardData.business_address.city,
            state: wizardData.business_address.state,
            zip: wizardData.business_address.postalCode,
            is_mock: wizardData.business_address.mock,
            phone: wizardData.business_address.supportPhone,
            // fax:
            email: wizardData.business_address.supportEmail
            // email_2:
            // valid:
            // standardized:
            // format:
            // info_id:
            // type:
            // linked_account_id:
            // created_date:
        }
    }
    if (wizardData?.business_info) {
        data = {
            ...data,
            // stock_exchange:
            stock_symbol: wizardData.business_info.stockSymbol,
            name: wizardData.business_info.brandName,
            // contact_id:
            'contact.name': wizardData.business_info.legalBizName,
            country: wizardData.business_info.registrationCountry,
            business_type_name: wizardData.business_info.selectedBizType,
            business_vertical_name: wizardData.business_info.selectedVerticle
        }
    }
    return data
}

const generateCampaignDescription = (useCases, brand) => {
    if (useCases.length === 1 && useCases[0]) {
        const uc = useCasesOptions.find((x) => x.id === useCases[0])
        if (uc && uc.campaignDescription) {
            return replacePlaceholderWithActualBrandValues(uc.campaignDescription, brand)
        }
        const other = getOtherUseCaseTextValue(useCases)
        if (other && useCases[0] === other) {
            return other
        }
    }
    // default to customerCare
    return replacePlaceholderWithActualBrandValues(
        (useCasesOptions.find((x) => x.id === 'SCHEDULE_APPOINTMENTS') || {}).campaignDescription,
        brand
    )
}

/**
 *
 */
const getAddCampaignParams = async (wizardData) => {
    const phonecom = await getPhoneCom()
    return {
        account_id: phonecom.voip_id,
        brandId: wizardData.campaign_usage.selectedBrand.csp_brand_id,
        campaignDescription: generateCampaignDescription(wizardData.campaign_usage.useCases, wizardData.campaign_usage.selectedBrand),
        campaignName: wizardData.campaign_usage.campaignName,
        campaign_usecase: {
            scheduleAppointments: wizardData.campaign_usage.useCases.includes('SCHEDULE_APPOINTMENTS'),
            orderStatus: wizardData.campaign_usage.useCases.includes('UPDATE_ORDER_STATUS'),
            salesOffer: wizardData.campaign_usage.useCases.includes('SALE_AND_OFFERS'),
            servicePromotions: wizardData.campaign_usage.useCases.includes('SERVICE_AND_EVENTS_PROMOTION'),
            customerSupport: wizardData.campaign_usage.useCases.includes('ASSISTENCE_AND_CUSTOMER_SUPPORT'),
            otherUseCase: getOtherUseCaseTextValue(wizardData.campaign_usage.useCases)
        },
        campaign_consent: {
            consentInfo: wizardData.campaign_usage.consentInfo,
            privacyPolicyUrl: wizardData.campaign_usage.privacyPolicyLink
        },
        campaign_message: {
            optInKeywords: '',
            optInMessage: wizardData.campaign_sms_content.optInMessage,
            optOutKeywords: '',
            optOutMessage: wizardData.campaign_sms_content.optOutMessage,
            helpKeywords: '',
            helpMessage: wizardData.campaign_sms_content.helpMessage
        },
        campaign_sms_content: {
            messageFlow: wizardData.campaign_usage.messageFlow,
            messageOne: wizardData.campaign_sms_content.samplesms1.value,
            messageTwo: wizardData.campaign_sms_content.samplesms2.value,
            messageThree: wizardData.campaign_sms_content.samplesms3.value,
            messageFour: wizardData.campaign_sms_content.samplesms4.value,
            messageFive: wizardData.campaign_sms_content.samplesms5.value
        },
        campaign_policies: {
            checked: wizardData.campaign_policies.checked,
            checked2: wizardData.campaign_policies.checked2,
            checked3: wizardData.campaign_policies.checked3
        },
        campaign_contact: {
            name: wizardData.campaign_contact.name,
            email: wizardData.campaign_contact.email
        },
        campaign_document_ids: wizardData.campaign_usage.files.map((x) => x.document_id || x.csp_document_id).filter(Boolean),
        // and now required fields
        campaign_preview: {},
        campaign_invoice: true,
        campaign_submit: {}
    }
}

/**
 *
 */
const getEditCampaignParams = async (wizardData, editing) => {
    const phonecom = await getPhoneCom()

    // payment-failed goes directly to the last step
    // so we dont have data before that
    let data = {
        account_id: phonecom.voip_id,
        csp_campaign_id: editing.csp_campaign_id
    }
    // identifier: '',
    // description: '',
    // deleted_at:null,
    if (wizardData?.campaign_sms_content) {
        data = {
            ...data,
            samplesms1: wizardData.campaign_sms_content.samplesms1.value,
            samplesms2: wizardData.campaign_sms_content.samplesms2.value,
            samplesms3: wizardData.campaign_sms_content.samplesms3.value,
            samplesms4: wizardData.campaign_sms_content.samplesms4.value,
            samplesms5: wizardData.campaign_sms_content.samplesms5.value,
            keywords: {
                start: {
                    // Campaignkeyword: "START",
                    CampaignkeywordValue: wizardData.campaign_sms_content.optInMessage
                },
                stop: {
                    // Campaignkeyword: "STOP",
                    CampaignkeywordValue: wizardData.campaign_sms_content.optOutMessage
                },
                help: {
                    // "Campaignkeyword": "HELP",
                    CampaignkeywordValue: wizardData.campaign_sms_content.helpMessage
                }
            }
        }
    }

    if (wizardData?.campaign_usage) {
        data = {
            ...data,
            consent_info: wizardData.campaign_usage.consentInfo,
            privacy_policy_url: wizardData.campaign_usage.privacyPolicyLink,
            // embedded_link: false,
            // embedded_phone: false,
            // number_pool: false,
            // age_gated: false,
            // direct_lending: false,
            // uc_appointments: false,
            // uc_orders: false,
            // uc_sales: false,
            // uc_promotions: false,
            // uc_support: false,
            // uc_other: '',
            // status:"",
            name: wizardData.campaign_usage.campaignName,
            messageflow: wizardData.campaign_usage.messageFlow,
            // created_at: 1689692286,
            // brand_name: "Phonee.comInc",
            csp_brand_id: wizardData.campaign_usage.selectedBrand.csp_brand_id
            // is_mock: "N",
            // use_cases: wizardData.campaign_usage.useCases, // it can't be updated anyway, and ee have situation with OTHER
        }
    }

    if (wizardData?.campaign_contact) {
        data = {
            ...data,
            contact_name: wizardData.campaign_contact.name,
            contact_email: wizardData.campaign_contact.email
        }
    }

    return data
}

/**
 *
 */
export {
    getAddBrandParams,
    getEditBrandParams,
    getAddCampaignParams,
    getEditCampaignParams
}
